/* eslint-disable @angular-eslint/no-input-rename */
/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[tooltip]',
  standalone: false,
})
export class TooltipDirective implements OnInit, OnDestroy, OnChanges {
  @Input() tooltip: string = '';
  @Input('hideTooltip') hide: boolean = false;

  timeout!: any;
  div!: HTMLDivElement;

  mouseEnterListener!: any;
  mouseLeaveListener!: any;

  constructor(
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    if (!this.hide) {
      this.timeout = setTimeout(() => {
        this.init();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hide']) {
      const { hide: { previousValue, currentValue } } = changes;
      if (previousValue !== currentValue) {
        if (currentValue === true) {
          this.destroy();
        } else {
          this.init();
        }
      }
    } else {
      this.init();
    }
  }

  init() {
    this.destroy();
    const e = (this.elementRef.nativeElement as HTMLElement);
    const { top, height, left } = e.getBoundingClientRect();
    this.div = document.createElement('div');
    this.div.textContent = this.tooltip;
    this.div.style.background = 'var(--ion-color-light)';
    this.div.style.padding = '16px';
    this.div.style.position = 'absolute';
    this.div.style.maxWidth = '300px';
    const divTop = top  + height + 15;
    if ((divTop + height) >= window.innerHeight) {
      this.div.style.top = `${top - height - 15}px`;
    } else {
      this.div.style.top = `${divTop}px`;
    }
    this.div.style.left = `${left}px`;
    this.div.style.borderRadius = '8px';
    this.div.style.boxShadow = '0 6px 15px -6px rgba(0,0,0,0.5)';
    this.div.style.color = 'var(--ion-color-text)';
    this.div.style.display = 'none';
    document.body.appendChild(this.div);
    this.mouseEnterListener = this.mouseEnter(this.div);
    this.mouseLeaveListener = this.mouseLeave(this.div);
    e.addEventListener('mouseenter', this.mouseEnterListener);
    e.addEventListener('mouseleave', this.mouseLeaveListener);
  }

  destroy() {
    const e = (this.elementRef.nativeElement as HTMLElement);
    this.div?.remove();
    e.removeEventListener('mouseenter', this.mouseEnterListener);
    e.removeEventListener('mouseleave', this.mouseLeaveListener);
    clearTimeout(this.timeout);
  }

  mouseEnter(e: HTMLDivElement) {
    return () => e.style.display = 'block';
  }

  mouseLeave(e: HTMLDivElement) {
    return () => e.style.display = 'none';
  }
}
